import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useTranslation, withTranslation } from 'react-i18next';
import { Grid, Box, Hidden, Button, MenuItem, Menu } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import { PlaceBlackIcon, HomeIcon, RisedHandIcon, TuneWhiteIcon } from '../../components/icons';
import { GiftIcon, StarIcon, ReNewIcon, DateRangeBlackIcon } from '../../components/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomizedCircularProgress from '../../components/CircularProgress';
import ButtonCustom from '../../components/ButtonCustom';
import SubcriptionItem from './SubcriptionItem';
import { formatDateTimeFrEpoch, formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYY } from '../../utils/util';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { portalCfg } from '../../../portal.router.config';
import { custom_assets, domainName } from '../../../portal.config';

var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";


const styles = theme => ({
    container: {
        position: 'relative',
    },
    list: {
        marginTop: theme.spacing(1)
    },
    midHeader: {
        position: 'absolute',
        top: theme.spacing(0),
        right: theme.spacing(2),
    },
    button_Filter: {
        marginRight: theme.spacing(2),
        boxShadow: 'none',
        opacity: 1,
        cursor: "pointer",
        '&:hover': {
            opacity: 0.5,
        },
    },
    container_item: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        },
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        //height: 280,
        backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        padding: '15px 10px'
    },

    expense_container: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        },
    },
    expense_item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        //height: 280,
        backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        padding: '15px 10px'
    },
    expense_sub_img: {
        display: 'flex',
        alignItems: 'center'
    },
    expense_item_cover: {
        border: '1px solid ' + theme.palette.border.secondary,
        borderRadius: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginLeft: theme.spacing(1),
        "& img": {
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5),
        }
    },
    expense_status: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    expense_sub_date: {
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // height: 100
    }
});
function SubcriptionsView(props) {
    const { t } = useTranslation();
    const [showMenu, setShowMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const { classes, subcriptions, showLoading, hasMore, showLoadMore, currency, periodSelected, periods, onChangeTab, devices } = props;
    console.log("subcription====", subcriptions);
    console.log("periods====", periods);
    console.log("periodSelected====", periodSelected);

    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #d3d4d5',
            borderRadius: 12,
            top: '200px!important',
            width: 200,
        },
    })((props) => (
        <Menu
            id="subscription-menu"
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            {...props}
        />
    ));
    const listExpenseService = (subcriptions) =>{
        let expensesServicesHide = document._portalConfig.expensesServicesHide;
        if(expensesServicesHide && expensesServicesHide.length > 0){
            return subcriptions.filter(sub => sub.classification == 'EXPENSES_SERVICE' && sub.service && sub.service.product && sub.service.product.sku && !expensesServicesHide.includes(sub.service.product.sku));
        } else {
            return subcriptions.filter(sub => sub.classification == 'EXPENSES_SERVICE');
        }
    }   
    const listService = (subcriptions) => {
        return subcriptions.filter(sub => sub.classification != 'EXPENSES_SERVICE')
    }      
    return (
        <Container>
            <Grid xs={12} item className={classes.container}>
                <Grid xs={12} item container alignItems='center'>
                    <Typo mg_left_xl variant='h2' color='onPrimary'>{t('subcriptions_title')}&nbsp;</Typo>
                    <Grid item style={{ marginLeft: 20 }}>
                        {periods && periods.length > 0 && periods.map((period, index) => {
                            console.log("periodSelected == period: ", periodSelected == period);
                            return (
                                <Box key={index}>
                                    <ButtonCustom size='xs' color={periodSelected == period ? 'primary' : 'onPrimary'}
                                        fullWidth
                                        onClick={() => onChangeTab(period)}>
                                        {period == 1 ? t('monthly') : period + t('month_title')}
                                    </ButtonCustom>
                                </Box>
                            );
                        })}
                    </Grid>
                    {/* {portal_config[domainName].isShowServiceChanges && <Grid item style={{ marginLeft: 20 }}>
                        <Box>
                            <ButtonCustom size='sm' color={'onPrimary'} fullWidth onClick={(event) => setAnchorEl(event.currentTarget)}>
                                {t('btn_service_changes')}
                            </ButtonCustom>
                            <StyledMenu
                                id="custom-subscription-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                // open={showMenu}
                                open={Boolean(anchorEl)}
                                onClose={() => setAnchorEl(null)}
                            >
                                <MenuItem onClick={() => props.onUpgrade()}>
                                    <Typo>{t('upgrade_service')}</Typo>
                                </MenuItem>
                            </StyledMenu>
                        </Box>
                    </Grid>} */}
                </Grid>
                {showLoading && <CustomizedCircularProgress />}
                <Grid xs={12} item className={classes.list}>
                    {subcriptions && subcriptions[periodSelected] && listService(subcriptions[periodSelected]).length > 0 &&
                        <InfiniteScroll
                            dataLength={listService(subcriptions[periodSelected]).length} //This is important field to render the next data
                            next={props.handleLoadMore}
                            hasMore={hasMore}
                            loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        >
                            <Grid xs={12} item container className={classes.list}>
                                {listService(subcriptions[periodSelected]).map((item, idx) => (
                                    <SubcriptionItem
                                        key={idx}
                                        t={t}
                                        
                                        item={item}
                                        currency={currency} 
                                        from={'subscription_page'}
                                        onUpgradeService={props.onUpgrade}
                                        onRecurringPayment={props.onRecurringPayment}/>
                                ))}
                            </Grid>
                        </InfiniteScroll>
                    }
                </Grid>
                {subcriptions && subcriptions[periodSelected] && listExpenseService(subcriptions[periodSelected]).length > 0 && <Grid xs={12} item container alignItems='center'>
                    <Typo mg_left_xl variant='h2' color='onPrimary'>{t('expense_service')}&nbsp;</Typo>

                    <Grid xs={12} item className={classes.list}>

                        <InfiniteScroll
                            dataLength={listExpenseService(subcriptions[periodSelected]).length}>
                            <Grid xs={12} item container className={classes.list}>
                                {listExpenseService(subcriptions[periodSelected]).map((item, idx) => (
                                    <ExpenseServiceItem
                                        key={idx}
                                        t={t}
                                        classes={classes}
                                        item={item}
                                        currency={currency}
                                        from={'subscription_page'}
                                        onUpgradeService={props.onUpgrade}
                                        onRecurringPayment={props.onRecurringPayment} />
                                ))}
                            </Grid>
                        </InfiniteScroll>

                    </Grid>
                </Grid>}

                {devices && devices.length > 0 && <Grid xs={12} item container alignItems='center'>
                    <Typo mg_left_xl variant='h2' color='onPrimary'>{t('devices')}&nbsp;</Typo>

                    <Grid xs={12} item className={classes.list}>
                        
                            <InfiniteScroll
                            dataLength={devices.length}>
                                <Grid xs={12} item container className={classes.list}>
                                {devices.map((item, idx) => (
                                        <DeviceItem
                                            key={idx}
                                            classes={classes}
                                            t={t}
                                            item={item}
                                            currency={currency}
                                            from={'subscription_page'}
                                            onUpgradeService={props.onUpgrade}
                                            onRecurringPayment={props.onRecurringPayment} />
                                    ))}
                                </Grid>
                            </InfiniteScroll>
                        
                    </Grid>
                </Grid>}
                
                {/* <Grid item container className={classes.midHeader} direction='row' justify='flex-end' alignItems='center'>
                    {periods && periods.length > 0 && periods.map((period, index) => {
                        console.log("periodSelected == period: ", periodSelected == period);
                        return (
                            <Box key={index}>
                                <ButtonCustom size='xs' color={periodSelected == period ? 'primary':'onPrimary'}
                                    fullWidth 
                                    onClick={() => onChangeTab(period)}>
                                     {period == 1 ? t('monthly') : period + t('month_title')}
                                </ButtonCustom>
                            </Box>
                        );
                    })}
                </Grid> */}
            </Grid>
        </Container>
    );
}
function ExpenseServiceItem(props) {
    const { classes, t, item, currency, from } = props;
    // console.log("AAA item sub===", item);
    let images = dataUtil.getImageByUsageType(item.service && item.service.product ? item.service.product.creatives : null, usage_type.product_item);
    // console.log("AAA image sub===", images);
    let imageSub = path + '/images/logo.png';
    if (images && images.length > 0) {
        imageSub = images[0].uri;
    }
    return (
        <Grid xs={12} sm={6} md={6} lg={5} xl={4} item container className={classes.expense_container}>
            <Grid xs={12} item className={classes.expense_item}>
                <Grid item container style={{ alignItems: "center" }}>
                    <Grid item xs={12} md={9}>
                        <Grid item xs={12} className={classes.expense_sub_img}>
                            <Grid item className={classes.expense_item_cover}>
                                <img src={imageSub} alt="Image Service" />
                            </Grid>
                            <Typo variant='subtitle2' style={{ marginLeft: 10 }}>{item.service && item.service.product ? item.service.product.name : ""}</Typo>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} style={{ textAlign: 'right' }}>
                        <Typo variant='subtitle2' style={{ marginLeft: 10 }}>{currency}{item.service && item.service.price ? item.service.price.price.toFixed(2) : "0.00"}</Typo>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.expense_status}>
                    <ButtonCustom size="xs" color={"success"}>{item.service && item.service.life_cycle_state ? item.service.life_cycle_state : ''}</ButtonCustom>
                    {item.service && item.service.terms && item.service.terms.in_contract &&
                        <ButtonCustom size="xs" color={"info"}>{t('in_contract')}</ButtonCustom>}

                    {item.service && item.service.trial_period && item.service.trial_period.trial_state == "IN_TRIAL" &&
                        <ButtonCustom size="xs" color={"info"}>{t('in_trial')}</ButtonCustom>}
        

                </Grid>
                <Grid item container className={classes.expense_sub_date}>
                    {item.service && item.service.terms && item.service.terms.auto_renew && item.service.life_cycle_state != 'DRAFT' &&
                        <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                            <ReNewIcon />
                            <Grid item style={{ paddingLeft: 10 }}>
                                <Typo variant='subtitle2'>{t('auto_renew')}</Typo>
                                <Typo variant='body2'>{item.service.terms.termed_period && item.service.terms.termed_period.end_date ? formatDateToDDMMYYYYFrEpoch(item.service.terms.termed_period.end_date) : ''}</Typo>
                            </Grid>
                        </Grid>
                    }
                    {item.service && item.service.terms.in_contract
                        && item.service.terms.contract_period
                        && item.service.terms.contract_period.start_date
                        && item.service.terms.contract_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'> {t('sub_contract_period') + " "} </Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service && item.service.trial_period
                        && item.service.trial_period.end_date
                        && item.service.trial_period.start_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'>{t('sub_trial_period')}</Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.trial_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.trial_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service && item.service.terms.termed_period
                        && item.service.terms.termed_period.start_date
                        && item.service.terms.termed_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'> {t('latest_billed_period') + " "} </Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.termed_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.termed_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>

                {domainName == 'airlink' && <Grid item xs={12} container justifyContent='center' alignItems='center'>
                    <Grid item xs={12} lg={7} container>
                        {item.service && item.service.added_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{item.service.life_cycle_state == 'DRAFT' ? t('added_on') : t('active_since')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.added_on)}</Typo>
                            </Grid>
                        </Grid>}
                        {item.service && item.service.removed_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('removed_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.removed_on)}</Typo>
                            </Grid>
                        </Grid>}
                        {item.service && item.service.firts_activated_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('firts_activated_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.firts_activated_on)}</Typo>
                            </Grid>
                        </Grid>}
                    </Grid>
                    <Grid item xs={12} lg={5}>

                    </Grid>
                </Grid>}
                {/* <Grid item xs={12} container justifyContent='center'>

                    {from == 'subscription_page' && item.service && item.service.life_cycle_state != 'DRAFT' && <ButtonCustom size="xs" color={"primary"} onClick={() => props.onRecurringPayment(item)}>{t('recurring_payment')}</ButtonCustom>}

                </Grid> */}
            </Grid>
        </Grid>
    );
}
function DeviceItem(props) {
    const { item, classes, t } = props;
    const provision_name = item.enabled_services && item.enabled_services.length > 0 && item.enabled_services[0].product && item.enabled_services[0].product.name ? item.enabled_services[0].product.name : ''
    return(
        <Grid xs={12} sm={6} md={6} lg={5} xl={4} item container className={classes.container_item}>
            <Grid xs={12} item className={classes.item} container direction='row' alignItems='center'>
                <Typo variant='subtitle2' mg_left_sm>{item.device && item.device.serial_number ? item.device.serial_number : ""}</Typo>
                <ButtonCustom size="xs" color={"warning"}>{item.device && item.device.product && item.device.product.name ? item.device.product.name : ''}</ButtonCustom>
                {/* <ButtonCustom size="xs"  color={"success"}>{item.state ? item.state : ''}</ButtonCustom> */}
                
                {/* <Grid xs={12} item container direction='row' alignItems='center'>
                    <Typo variant='subtitle2' mg_left_sm>{t('on_customer_premises_since')}</Typo>
                    <Typo variant='body2' mg_left_sm>{item.provided_on ? formatDateToDDMMYYYYFrEpoch(item.provided_on) : ''}</Typo>
                </Grid>
                <Grid xs={12} item container direction='row' alignItems='center'>
                    <Typo variant='subtitle2' mg_left_sm>{t('provisions')}</Typo>
                    <Typo variant='body2' mg_left_sm>{provision_name}</Typo>
                </Grid> */}
            </Grid>
           
        </Grid>
    )

}
export default withStyles(styles)(withTranslation()(SubcriptionsView));